<cap-content-header>
  <cap-title>
    {{ "neskoab.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<div class="pt-2">
  <form (ngSubmit)="onSubmit()" [meta]="searchRequest" #form="ngForm">
    <fieldset>
      <cap-form-row column-classes="col-md-1,col-md-1">
        <cap-form-control column-classes="col-md-2,col-md-2" invalidKey="GemeindeMussVorhandenSein" labelKey="Gemeinde">
          <cap-gb-gemeinde
            (ngModelChange)="searchRequest && (searchRequest.gbGemeindeId = $event)"
            [hasfocus]="true"
            [ngModel]="searchRequest && searchRequest.gbGemeindeId"
            [nurGueltige]="false"
            [searchMode]="gbGemeindeSearchMode"
            class="typeahead-holder"
            name="gbGemeindeId">
          </cap-gb-gemeinde>
          <span>
            <button (click)="emptyGemeindeSearch()" class="btn btn-white emptyGemeindeButton" tabindex="-1" type="button">
              <span class="fas fa-times"></span>
            </button>
          </span>
        </cap-form-control>

        <cap-form-control invalidKey="EingabeMussValideNummerSein5Stellen>80k" labelKey="Nummer">
          <input
            (ngModelChange)="searchRequest && (searchRequest.nummer = $event)"
            [ngModel]="searchRequest && searchRequest.nummer"
            name="nummer"
            size="10"
            type="text" />
        </cap-form-control>

        <cap-form-control column-classes="col-md-1, col col-md-1 input-series" invalidKey="EingabeMussValideNummerSein" labelKey="Index">
          <input
            (ngModelChange)="searchRequest && (searchRequest.nummer2 = $event)"
            [ngModel]="searchRequest && searchRequest.nummer2"
            name="grundstueckNummer.nummer2"
            size="6"
            type="text" />
        </cap-form-control>
        <cap-form-control column-classes="px-0 input-series, col col-md-1 input-series" invalidKey="EingabeMussValideNummerSein">
          <input
            (ngModelChange)="searchRequest && (searchRequest.nummer3 = $event)"
            [ngModel]="searchRequest && searchRequest.nummer3"
            class="index-last"
            name="grundstueckNummer.nummer3"
            size="6"
            type="text" />
        </cap-form-control>
      </cap-form-row>
    </fieldset>
    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
        <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
      </div>
    </div>
  </form>
</div>
